module.exports = __webpack_public_path__ + "img/pts.0976815.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pts.svg?y08y5r
// module id = 1088
// module chunks = 0